"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BotBonusApi = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
var BotBonusApi;
(function (BotBonusApi) {
    BotBonusApi.requestUserBotBonus = () => {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost + "/bonus/";
        return trade_utils_lib_1.Network.get({ url: url, authType: trade_utils_lib_1.AuthType.Access });
    };
    BotBonusApi.requestBotBonus = (bonusId) => {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost + `/bonus/${bonusId}/`;
        return trade_utils_lib_1.Network.get({ url: url, authType: trade_utils_lib_1.AuthType.Access });
    };
    BotBonusApi.collectBotBonus = (bonusId) => {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost + `/bonus/${bonusId}/collect/`;
        return trade_utils_lib_1.Network.post({
            url: url,
            authType: trade_utils_lib_1.AuthType.Access,
        });
    };
    BotBonusApi.requestBotBonusRecord = () => {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost + "/bonus/records/";
        return trade_utils_lib_1.Network.get({ url: url, authType: trade_utils_lib_1.AuthType.Access });
    };
    /** 发财金报名+领取 用于简化敢赔单活动下单 */
    BotBonusApi.bonusTaskRegisterAndCollect = (task_id) => {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost + `/bonus/task/${task_id}/register_collect/`;
        return trade_utils_lib_1.Network.post({ url: url, authType: trade_utils_lib_1.AuthType.FullToken });
    };
    /**
     * 发财金活动报名
     * @param task_id
     * @returns
     */
    BotBonusApi.bonusTaskRegister = (task_id) => {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost + `/bonus/task/${task_id}/register/`;
        return trade_utils_lib_1.Network.post({ url: url, authType: trade_utils_lib_1.AuthType.FullToken });
    };
    /**
     * 未登录获取发财金详情
     * @param task_id
     * @returns
     */
    BotBonusApi.bonusTaskDetail = (task_id) => {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost + `/bonus/task/detail/${task_id}/`;
        return trade_utils_lib_1.Network.get({ url: url, authType: trade_utils_lib_1.AuthType.None });
    };
    /**
     * 检查发财金活动状态
     * @param task_id
     * @returns
     */
    BotBonusApi.checkBonusTaskState = (bonus_id) => {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost + `/bonus/task/${bonus_id}/check/`;
        return trade_utils_lib_1.Network.get({ url: url, authType: trade_utils_lib_1.AuthType.FullToken });
    };
    /**
     * 发财金活动领取
     * @param task_id
     * @returns
     */
    BotBonusApi.bonusTaskClaim = (bonus_id) => {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost + `/bonus/task/${bonus_id}/collect/`;
        return trade_utils_lib_1.Network.post({ url: url, authType: trade_utils_lib_1.AuthType.FullToken });
    };
})(BotBonusApi || (exports.BotBonusApi = BotBonusApi = {}));
